/*
 * coming-soon.js — hard-disable every Add-to-Cart on coming-soon product pages.
 *
 * The Liquid-level swap in buy-buttons.liquid catches the main product form, but
 * GemPages / third-party sections render their own ATC buttons that bypass that
 * snippet. The CSS fallback covers visual state, but customers can still submit
 * the form with Enter. This script:
 *   1. Detects coming-soon handle via <body data-product-handle>.
 *   2. Rewrites every button[name="add"], .atc-button, .product-form__submit,
 *      .quick-add__submit label to "COMING SOON" and disables it.
 *   3. Intercepts submit on any form whose action points to /cart/add and
 *      prevents the request entirely.
 *   4. Re-runs on DOM mutations (sticky/dynamic sections, variant re-renders).
 */
(function () {
  'use strict';

  var COMING_SOON = ['restore-balm'];
  var LABEL = 'COMING SOON';
  var BUTTON_SELECTOR = [
    'button[name="add"]',
    '.atc-button',
    '.product-form__submit',
    '.quick-add__submit',
    '.new-custom-bundle-product-btn',
    '.sdp-atc',
    '.sdp-cta',
    'button[type="submit"].button',
  ].join(',');

  function isComingSoonPage() {
    var h = document.body && document.body.dataset && document.body.dataset.productHandle;
    return h && COMING_SOON.indexOf(h) !== -1;
  }

  function neutralizeButton(btn) {
    if (!btn || btn.dataset.comingSoonApplied === '1') return;
    btn.dataset.comingSoonApplied = '1';
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('tabindex', '-1');
    btn.style.cursor = 'not-allowed';
    btn.style.opacity = '0.85';
    btn.style.pointerEvents = 'none';
    var label =
      btn.querySelector('.main-atc__label__text') ||
      btn.querySelector('.button__label') ||
      btn.querySelector('span');
    if (label) {
      label.textContent = LABEL;
    } else {
      btn.textContent = LABEL;
    }
  }

  function blockForm(form) {
    if (!form || form.dataset.comingSoonBound === '1') return;
    form.dataset.comingSoonBound = '1';
    form.addEventListener(
      'submit',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true
    );
  }

  function sweep(root) {
    var scope = root || document;
    scope.querySelectorAll(BUTTON_SELECTOR).forEach(neutralizeButton);
    scope.querySelectorAll('form[action*="/cart/add"]').forEach(blockForm);
  }

  function init() {
    if (!isComingSoonPage()) return;
    sweep(document);
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) sweep(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
